import { FC, useState } from "react"
import './delete.css'

const Delete: FC = () => {

    const [termo, setTermo] = useState(false)

    const solicitar = async () => {
        console.log('solicitar deletar')
    }

    return (
        <div className="deleteContent">
            <div className="deleteHeader">
                <h4>Solicitar exclusão da conta</h4>
            </div>
            <span>
                Ao cancelar o seu cadastro no sistema, você vai perder acesso a informações, pedidos e funcionalidades. Sem o cadastro você não terá mais acesso às suas informações pessoais armazenadas na conta e também perderá todos os benefícios associados à mesma. Além disso, você não será mais capaz de realizar compras nem acompanhar compras anteriores. Certifique-se de avaliar todas as consequências possíveis para evitar arrependimentos futuros.
                A sua solicitação será encaminhada ao time de suporte que irá processar o pedido em até 2 dias úteis. Você receberá uma notificação quando a conta for excluída.
                Mesmo com a exclusão da conta no sistema, informações pessoais poderão ficar armazenadas no histórico de pedidos e transações comerciais. Para saber mais,acesse os <button id="linkButton">termos de uso</button> do sistema.
            </span>

            {/*Checkbox*/}
            <div className="checkbox">
                <div className="password-Input">
                    <input
                        className=""
                        type={"checkbox"}
                        checked={termo}
                        onChange={(event) => setTermo(event.target.checked)}
                    />
                </div>
                <div className="headers">
                    <span>  Estou ciente das informações e desejo solicitar a exclusão da minha conta</span>
                </div>
            </div>


            <div className="buttomCadastro">
                <button
                    style={{
                        background: "#6E7586",
                        color: "white",
                        border: "none",
                    }}
                    onClick={() => solicitar()}
                >Solicitar exclusão</button>
            </div>
        </div>
    )
}

export { Delete }